.tooltip {
  z-index: var(--z-tooltip);
  max-width: 280px;
  padding: var(--space-1-5) var(--space-2);
  border-radius: var(--radius-sm);
  background: var(--color-text);
  color: var(--color-bg);
  font-size: var(--text-xs);
  font-weight: var(--weight-medium);
  line-height: var(--leading-snug);
  box-shadow: var(--shadow-md);
  animation: appear var(--duration-fast) var(--ease-standard);
}

@keyframes appear {
  from {
    opacity: 0;
    transform: translateY(2px);
  }
}
